import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import References from "../../components/References";
import PlaqueEnhancedSR2 from "../../assets/module-1/Plaque-Enhanced-SR-2.png";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.0.3 Beta-Amyloid as an Early Biomarker
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="row">
            <div className="col-sm-12 col-md-6">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border"
                textContent={
                  <>
                    <p>
                      Bielschowsky silver stained tissue section; Nixon RA. <em>J Cell Sci.</em> 2007;120:4081-4091.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={PlaqueEnhancedSR2}
                  alt="Microscopic image of a Bielschowsky silver stained tissue section showing plaque and neurofibrillary tangles (NFT) in brain tissue, with arrows indicating the locations."
                  style={{ maxWidth: "700px" }}
                />
              </FigureCaption>
            </div>
            <div className="col-sm-12 col-md-6">
              <p>
                Beta-amyloid deposition is a defining neuropathology of AD.<sup>1,2</sup> The presence of beta-amyloid neuritic plaques, thought to arise from abnormal accumulation of soluble beta-amyloid over time,<sup>3</sup> is a necessary pathological feature of AD.<sup>1,4</sup>
              </p>
              <p>
                Evidence of amyloid plaque accumulation has been shown to be
                present when symptoms of cognitive impairment, due to AD,
                appear.<sup>5-7</sup>
              </p>
              <ul class="ms-1">
                <li>
                  May precede the appearance of clinical symptoms by approximately 20 years
                </li>
              </ul>
              <p className="mb-5">
                Beta-amyloid neuritic plaques may also be present in patients with other types of neurologic conditions, as well as older people with normal cognition. The presence of amyloid plaques alone does not establish a diagnosis of AD or other cognitive disorders.<sup>1</sup>
              </p>
            </div>
          </section>
          <section className="button-control mb-0">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-0-2", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-0-4", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <section className="row mt-0 mb-5">
            <p className="fz-sm">NFT=neurofibrillary tangles.</p>
          </section>

          <References>
            <ol className="no-indent fz-sm">
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.{" "}
              </li>
              <li>
                Jack CR, Jr., et al. <em>Alzheimers Dement.</em>{" "}
                2011;7(3):257-262.{" "}
              </li>
              <li>Watson D, et al. <em>Neurol Res.</em> 2005;27(8):869-881. </li>
              <li>
                Jack CR, Jr., et al. <em>Lancet Neurol.</em> 2013;12(2):207-216.{" "}
              </li>
              <li>
                Villemagne VL, et al. <em>Lancet Neurol.</em>{" "}
                2013;12(4):357-367.{" "}
              </li>
              <li>
                Alzheimer's Association. <em>Alzheimers Dement.</em>{" "}
                2022;18:700-789.{" "}
              </li>
              <li>
                Hyman BT, et al. <em>Alzheimers Dement.</em> 2012;8(1):1-13.{" "}
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_0_3;
